import { useTranslation } from "react-i18next";

import { Button } from "@digital-services/ui";

import { useOrganizationContext } from "@organization/context/useOrganizationContext";
import { OrganizationStatus } from "@organization/models/OrganizationDetails";
import { InviteFormContextProvider } from "@user/context";

import { useDrawerWithConfirm } from "@hooks/useDrawerWithConfirm";
import InviteUserIcon from "@icons/invite_user.svg?react";

import { InviteAdminForm } from "./InviteAdminForm";

interface Props {
  organizationId: string;
  afterCallback?: () => void;
}

// !!! <InviteOrganizationAdminButton> render 8 times: 4 times because of MSAL attempt to authenticate and 4 times because of <StrictMode>
// TBD - migrate to @digital-services/auth
export const InviteOrganizationAdminButton = (props: Props) => {
  const { organizationId } = props;
  const { organization } = useOrganizationContext();
  const { t } = useTranslation(undefined, { keyPrefix: "organization.admin" });

  const { showDrawer, hideDrawer } = useDrawerWithConfirm();

  const inviteAdmin = () => {
    showDrawer({
      title: t("invite.title"),
      children: (
        <InviteFormContextProvider>
          <InviteAdminForm
            organizationId={organizationId}
            onCancel={() => hideDrawer()}
            onSave={() => {
              hideDrawer();
              if (props.afterCallback) {
                props.afterCallback();
              }
            }}
          />
        </InviteFormContextProvider>
      )
    });
  };

  return (
    <Button
      disabled={organization.status === OrganizationStatus.InActive}
      icon={<InviteUserIcon className="h-[18px]" />}
      data-testid="invite-admin-button"
      variant="primary"
      onClick={inviteAdmin}
    >
      {t("invite.label")}
    </Button>
  );
};
